// extracted by mini-css-extract-plugin
export default {"venueSlider":"VenueCarousel_venueSlider__-+l0h","rightArrow":"VenueCarousel_rightArrow__hkV+4","leftArrow":"VenueCarousel_leftArrow__IoOdj","image":"VenueCarousel_image__smJ76"};